import { css } from '@emotion/css';
import React from 'react';
import { throttle } from '../../../lib/utils';

interface RoundedButtonProps {
  color: string;
  background: string;
  disabled?: boolean;
  loading?: boolean;
  fontSize?: number;
  onClick?: () => void;
}

export const RoundedButton: React.FC<RoundedButtonProps> = ({
  children,
  color,
  background,
  onClick,
  disabled,
  loading,
  fontSize
}) => {
  return (
    <button
      className={css`
        width: 100%;
        height: 56px;
        color: ${disabled ? '#8f8c85' : color};
        font-size: ${fontSize || 16}px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background: ${disabled ? '#cdc7bb' : background};
        border-radius: 28px;
        border: 3px solid #f5f1e3;
        transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49), background 0.1s;
        &:disabled {
          pointer-events: none;
        }
        &:active {
          transform: scale(0.98, 0.95);
        }
      `}
      disabled={disabled || loading}
      onClick={onClick && throttle(onClick, 1000, 200)}
    >
      {children}
    </button>
  );
};
